import React from 'react';
import Model from '../common/models/Model';
import { Button } from '../common/Button';
import useI18n from '../../hooks/useI18n';
import { useNavigate } from 'react-router-dom';

interface UrlNotExistModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UrlNotExistModal: React.FC<UrlNotExistModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <Model
      isOpen={isOpen}
      className="!bg-black !bg-opacity-40"
      onClose={onClose}
    >
      <div className="flex flex-col w-[26rem] gap-2">
        <h1 className="font-semibold text-base font-content">
          {t('common.socialUrlsHeading')}
        </h1>
        <div className="my-4 text-sm text-gray-700">
          {t('common.socialUrlsDesc')}
        </div>
        <div className="flex justify-space gap-4">
          <Button
            className="flex-1 inline-flex items-center justify-center rounded-full"
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          >
            {t('common.doItLater')}
          </Button>{' '}
          <Button
            className="flex-1 inline-flex items-center justify-center rounded-full"
            onClick={() => {
              navigate('/profile?tab=social');
            }}
          >
            {t('common.connectNow')}
          </Button>
        </div>
      </div>
    </Model>
  );
};

export default UrlNotExistModal;
